import Header from "./Header";
import Pride from "./Pride";
import Blogs from "./Blogs";
import Slider from "./Slider";
import Contact from "./Contact";
import Ingredients from "./Ingredients";
import { Fragment } from "react";
import "./Home.css";

const Home = () => {
  return (
    <Fragment>
      <Header />
      <section className="numbers ">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <h2> 1547 + </h2> <h6> SAVINGS </h6>{" "}
            </div>{" "}
            <div className="col-md-3">
              <h2> 7847 + </h2> <h6> PHOTOS </h6>{" "}
            </div>{" "}
            <div className="col-md-3">
              <h2> 4700 + </h2> <h6> ROCKETS </h6>{" "}
            </div>{" "}
            <div className="col-md-3">
              <h2> 11200 + </h2> <h6> GLOPES </h6>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </section>{" "}
      <Pride />
      <Ingredients />
      <div className="story">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ">
              <h2>
                When a man 's stomach is full it makes no difference whether he
                is rich or poor.{" "}
              </h2>{" "}
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.Etiam et
                purus a odio finibus bibendum in sit amet leo.Mauris feugiat
                erat tellus.{" "}
              </p>{" "}
              <a href="#"> Watch Our Story </a>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
      <Blogs />
      <Slider />
      <section className="Questions">
        <div className="container">
          <div className="row title-row">
            <div className="col-md-12">
              <h2>Frequently Asked Questions</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <h4>
                <span>~</span> Is Foodera Bread really baked fresh each day?
              </h4>
              <p>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia, there live the blind texts. Separated
                they live in Bookmarksgrove right at the coast of the Semantics,
                a large language.
              </p>
            </div>
            <div className="col-md-6">
              <h4>
                <span>~</span> Do you bake breads containing animal fats or
                products?
              </h4>
              <p>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia, there live the blind texts. Separated
                they live in Bookmarksgrove right at the coast of the Semantics,
                a large language.
              </p>
            </div>
            <div className="col-md-6">
              <h4>
                <span>~</span> Do you bake breads containing animal fats or
                products?
              </h4>
              <p>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia, there live the blind texts. Separated
                they live in Bookmarksgrove right at the coast of the Semantics,
                a large language.
              </p>
            </div>
            <div className="col-md-6">
              <h4>
                <span>~</span> When are you opening a shop near me?
              </h4>
              <p>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia, there live the blind texts. Separated
                they live in Bookmarksgrove right at the coast of the Semantics,
                a large language.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="breaking-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h2>Baked fresh daily by bakers with passion.</h2>
            </div>
            <div className="col-md-6">
              <button>learn more</button>
            </div>
          </div>
        </div>
      </section>
      <Contact />
    </Fragment>
  );
};

export default Home;
